import React from 'react';

import { yupResolver } from '@hookform/resolvers/yup';
import {
  Button,
  Grid
} from '@mui/material';
import _ from 'lodash';
import {
  authService,
  BaseOnboardingTemplate,
  fields,
  LoadingOverlay,
  routeDirectory,
  useStringQueryValue,
  validationUtil
} from 'modules';
import {
  FieldErrors,
  useForm
} from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';



const __formSchema = yup.object({
  code: validationUtil.codeSchema,
  password: validationUtil.passwordSchema.required('Password is required.'),
  confirmPassword: validationUtil.passwordSchema.oneOf([yup.ref('password')], '')
});

type IFormData = yup.InferType<typeof __formSchema>;

const ControlledTextField = fields.genTextFieldControllerComponent<IFormData>();



export const ResetPasswordActivity: React.FC = () => {
  const form = useForm<IFormData>({
    resolver: yupResolver(__formSchema)
  });

  const [loading, setLoading] = React.useState(false);

  const email = useStringQueryValue({
    key: 'email',
    fnPreProcess: val => _.replace(val, /\+/, '%2B')
  });
  const navigate = useNavigate();



  async function processSubmit(data: IFormData) {
    setLoading(true);
    try {
      await authService.forgotPasswordSubmit(email, data.code, data.password);
      alert('Your password has been reset successfully! Please log in with your new password.');

      navigate(routeDirectory.authentication.login.path());
    } catch (e) {
      // TODO: Handle Amplify errors
      if ((e as Error).name === 'ExpiredCodeException') {
        alert('Code is expired. Please try to reset again.');

      } else if ((e as Error).name === 'CodeMismatchException') {
        alert('Code doesn\'t match. Please try again.');

      } else {
        alert((e as Error).message);
      }
    }

    setLoading(false);
  }



  function handleFormError(e: FieldErrors<IFormData>) {
    if (e.confirmPassword) {
      alert('Passwords do not match.');
    }
  }



  return (
    <BaseOnboardingTemplate.FC
      stepperMode="none"
      title="Reset Password"
      subtitle={`Reset your password for ${email} in order to continue logging in to your account.`}>

      <LoadingOverlay active={loading} />

      <form onSubmit={form.handleSubmit(processSubmit, handleFormError)}>
        <Grid container spacing={3}>
          <Grid
            item
            xs={6}>
            <ControlledTextField
              fieldKey="code"
              label="Code"
              formControl={form.control} />
          </Grid>

          <Grid item xs={6} />

          <Grid
            item
            xs={5}>
            <ControlledTextField
              fieldKey="password"
              label="Password"
              type="password"
              formControl={form.control} />
          </Grid>

          <Grid
            item
            xs={5}>
            <ControlledTextField
              fieldKey="confirmPassword"
              label="Confirm password"
              type="password"
              formControl={form.control} />
          </Grid>

          <Grid
            item>
            <Button type="submit">
              Reset Password
            </Button>
          </Grid>
        </Grid>
      </form>
    </BaseOnboardingTemplate.FC>
  );
};
